import axios from 'axios'
import library from '../../../utils/Library'

export const updateFirmStaffRole = async (userData) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') + '/replaceAppRoleFromUserEAuthz'
  return await axios({
    url: URL,
    method: 'POST',
    data: userData,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
